import React from 'react';
import PropTypes from 'prop-types';
const HeaderTopBar = ({
    content
}) => {
    return (
        <div className="tw-w-full tw-bg-orange-400 tw-text-white tw-text-center tw-py-2">
            {content}
        </div>
    );
}

HeaderTopBar.defaultProps = {
    content: null,
}

HeaderTopBar.propTypes = {
    content: PropTypes.node,
};

export default HeaderTopBar;
